import React, { useState } from "react";
import { clientLogoIds, driveThumb } from "../data/categoriesData";

// Single logo tile. Hides itself when the Drive thumbnail fails to load
// (i.e. the client deleted the file from Drive). Lets the marquee stay
// clean without a code deploy when logos churn.
const LogoTile = ({ id, idx }) => {
  const [broken, setBroken] = useState(false);
  if (broken) return null;
  return (
    <div
      data-testid={`client-logo-${idx}`}
      className="shrink-0 h-16 sm:h-20 lg:h-24 w-32 sm:w-44 lg:w-52 flex items-center justify-center"
    >
      <img
        src={driveThumb(id, 600)}
        alt="Client logo"
        className="max-h-full max-w-full object-contain opacity-90 hover:opacity-100 transition-opacity duration-500"
        loading="lazy"
        draggable={false}
        onError={() => setBroken(true)}
      />
    </div>
  );
};

// Client logo marquee. Transparent backdrop — logos read directly on the
// editorial black canvas. Broken/deleted Drive files auto-hide.
export const ClientLogos = () => {
  const loop = [...clientLogoIds, ...clientLogoIds];

  return (
    <section
      data-testid="clients-section"
      className="relative bg-black border-t border-white/5 py-16 sm:py-24 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14 mb-10 sm:mb-14">
        <div className="flex items-center gap-8">
          <div className="eyebrow">§ 06 / In Trusted Company</div>
          <div className="h-[1px] bg-white/10 flex-1" />
        </div>
      </div>

      <div className="relative">
        <div
          data-testid="clients-marquee"
          className="flex marquee-track w-max items-center gap-14 sm:gap-24"
        >
          {loop.map((id, i) => (
            <LogoTile key={id + i} id={id} idx={i} />
          ))}
        </div>

        <div className="absolute top-0 bottom-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-black via-black/80 to-transparent pointer-events-none" />
        <div className="absolute top-0 bottom-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-black via-black/80 to-transparent pointer-events-none" />
      </div>
    </section>
  );
};

export default ClientLogos;
